// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import IndexController from "./index_controller.js"
application.register("index", IndexController)

import FilterController from "./filter_controller.js"
application.register("filter", FilterController)
